import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import React from 'react';
import useRect from 'hooks/common/useRect';
import { Chart } from 'chart.js';

const config = ({
  caption,
  value,
}, onComplete, duration) => ({
  type: 'doughnut',
  data: {
    labels: ['현재값', '나머지'],
    datasets: [{
      data: value,
      backgroundColor: ['#EAEAEA', '#FF995A', '#5100FF', '#13C1C7'],
      hoverBackgroundColor: ['#c0c0c0', '#FF995A80', '#5100FF80', '#13C1C780'],
      borderWidth: 0,
    }]
  },
  options: {
    devicePixelRatio: 4,
    animation: {
      duration,
      onComplete,
    },
    responsive: true,
    maintainAspectRatio: false,
    rotation: 0,
    circumference: 360,
    cutout: '70%',
    plugins: {
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false
      },
    }
  },
  plugins: [{
    afterDraw: function (chart) {
      const { ctx, chartArea: { width, height } } = chart;
      ctx.save();

      ctx.font = 'bold 13px Pretendard';
      ctx.fillStyle = '#000000';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'center';
      ctx.fillText(caption, width * 0.5, height * 0.5 + 5);
      ctx.restore();
    }
  }],
});


export default function DoughnutChart(props) {
  const {
    caption,
    value,
    onComplete,
    duration,
    ...rest
  } = props || {};

  const ref = React.useRef();
  const rect = useRect(ref);
  const canvasRef = React.useRef();
  const chartRef = React.useRef();
  React.useEffect(() => {
    const chart = new Chart(canvasRef.current, config({
      caption,
      value,
    }, onComplete, duration));
    chartRef.current = chart;
    return () => {
      chart.destroy();
      delete chart.config;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caption, value.join(','), onComplete, duration]);
  React.useLayoutEffect(() => {
    if (!chartRef.current) return;
    const frameId = requestAnimationFrame(() => {
      chartRef.current.update();
    });
    return () => {
      cancelAnimationFrame(frameId);
    };
  }, [rect]);

  return (
    <div
      {...ex(['Chart', 'DoughnutChart'], rest)}
      {...{ ref }}
    >
      <canvas
        {...{
          ref: canvasRef,
          width: rect.width,
          height: rect.height,
        }}
      />
    </div>
  );
}
